export function GetMonthList() {
    return ["choose-month", "january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
}